"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = (length) => Array.apply(null, { length }).map(Number.call, Number);
function stringsToEnum(strings) {
    return strings
        .reduce((result, key) => {
        result[key] = key;
        return result;
    }, Object.create(null));
}
exports.stringsToEnum = stringsToEnum;



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/utils/array.ts
// module id = 106
// module chunks = 0